module.exports = __webpack_public_path__ + "img/main-banner.5ad405eb.png";